var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.followed)?_c('f7-button',{class:"requested-btn"},[_vm._v(_vm._s(this.displayStatus(_vm.role,_vm.followed)))]):_c('f7-button',{class:"follow-btn",on:{"click":function (){ return _vm.request(); }}},[_vm._v("FOLLOW")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }